<template>
    <div
        class="ls-action-button--container"
        :class="{ 'ls-action-button--disabled': disabled_label }"
        test-id="container"
        @click="onClick"
    >
        <div class="ls-action-button--label">
            <div>
                <span>{{ label }}</span>
                <p v-if="disabled_label" test-id="disabled-text">{{ disabled_label }}</p>
            </div>
            <div v-if="!disabled_label">
                <LsIcon
                    v-if="next_service_within_48_hours"
                    type="time"
                    color="danger"
                    size="md"
                    filled
                />
                <LsIcon v-else type="chevron" color="secondary" />
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { LsIcon } from '@/components/common';

export default {
    name: 'LsActionButton',
    components: { LsIcon },
    props: {
        action: VueTypes.string.isRequired,
        // eslint-disable-next-line vue/prop-name-casing
        next_service_within_48_hours: VueTypes.bool.def(false),
        // eslint-disable-next-line vue/prop-name-casing
        disabled_label: VueTypes.string,
        service: VueTypes.shape({
            __typename: VueTypes.string.isRequired,
            id: VueTypes.string.isRequired,
            manualquote: VueTypes.oneOfType([
                VueTypes.shape({
                    quoted_schedule_id: VueTypes.number.isRequired,
                }).loose,
                VueTypes.oneOfType([null]),
            ]),
            schedule: VueTypes.shape({
                id: VueTypes.string.isRequired,
            }).loose,
        }).isRequired.loose,
    },
    computed: {
        label() {
            return _.uppercase(this.action);
        },
    },
    methods: {
        onClick() {
            if (this.disabled_label) {
                return;
            }

            if (this.action === 'viewJobDetails') {
                const { __typename } = this.service;
                const id =
                    __typename === 'Recommendation' || __typename === 'RequiredService'
                        ? this.service.schedule.id
                        : this.service.manualquote.quoted_schedule_id;

                return this.$router.push({
                    name: 'schedule',
                    params: {
                        customer_id: this.$route.params.customer_id,
                        property_id: this.$route.params.property_id,
                        schedule_id: id,
                    },
                });
            }

            this.$router.push({
                name: this.action,
                params: {
                    customer_id: this.$route.params.customer_id,
                    property_id: this.$route.params.property_id,
                    schedule_id: this.service.id,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-action-button--container {
    padding: 20px 15px 20px 20px;
    display: flex;
    align-items: center;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
    height: 80px;
    background-color: $white;
    cursor: pointer;
    user-select: none;
}

.ls-action-button--label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    span {
        color: $secondary-dark;
        font-size: 1.8rem;
    }
    p {
        font-size: 1.2rem;
    }
}

.ls-action-button--disabled {
    cursor: not-allowed;
    span {
        color: $gray-primary;
    }
}
</style>
